import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';
import Link from '@arcblock/www/src/components/link';

import Logo from '../header/logo';

import Header from '../header';

const SidebarWrapper = React.forwardRef((props, ref) => (
  <Div ref={ref} open={props.responsive ? props.open : false} width={props.meta.sidebarWidth}>
    <StyledHeader>
      <StyledLink to={props.meta.logoUrl || '/'}>
        <Logo version={props.version} title={props.meta.title} />
      </StyledLink>
    </StyledHeader>
    <Content>{props.children}</Content>
  </Div>
));

SidebarWrapper.displayName = 'SidebarWrapper';
SidebarWrapper.propTypes = {
  children: PropTypes.node.isRequired,
  version: PropTypes.string.isRequired,
  meta: PropTypes.object.isRequired,
  open: PropTypes.bool,
  responsive: PropTypes.bool,
};

SidebarWrapper.defaultProps = {
  open: false,
  responsive: false,
};

export default SidebarWrapper;

const Div = styled.aside`
  flex-shrink: 0;
  width: ${props => props.width}px;
  overflow-y: auto;
  position: relative;
  box-shadow: 2px 16px 10px 0 rgba(0, 0, 0, 0.05);
  @media screen and (max-width: ${props => props.theme.breakpoints.values.md}px) {
    height: 100%;
    background-color: ${props => props.theme.palette.background.default};
    position: absolute;
    top: 0;
    left: 0;
    z-index: 2;
    opacity: ${props => (props.open ? 1 : 0)};
    visibility: ${props => (props.open ? 'visible' : 'hidden')};
    transform: ${props => (props.open ? 'none' : 'translateX(-100%)')};
    transition-property: transform, opacity, visibility;
    transition-duration: 150ms;
    transition-timing-function: ease-in-out;
  }
`;

const StyledHeader = styled(Header)`
  font-size: 18px;
`;

const StyledLink = styled(Link)`
  color: inherit;
  display: flex;
  text-decoration: none;
`;

const Content = styled.div`
  padding: 16px 16px 72px 16px;
  padding-right: 0;
`;
